<div class="w-full space-y-1.5 block">
  @if (label) {
    <label
      [for]="control || label"
      class="mt-1 mb-[11px] block text-sm font-medium text-gray-700 leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
      [ngClass]="{ required: required }">
      {{ label }}

      @if (formControl.hasError('required')) {
        <span class="text-primary">*</span>
      }
    </label>
  }

  @if (control) {
    <ng-select
      [class]="className"
      [formControlName]="control"
      [id]="control"
      [readonly]="readOnly"
      [multiple]="multiple"
      (change)="onChange.emit($event)"
      (search)="onSearch.emit($event)"
      [loading]="loading"
      [clearable]="clearable"
      [searchable]="searchable"
      [placeholder]="placeholder">
      @if (multiple) {
        <ng-template ng-header-tmp>
          <div class="flex items-center justify-between px-2 py-1">
            <button hlmBtn size="sm" variant="link" class="!p-0 hover:no-underline hover:opacity-50"
                    (click)="onSelectAll()">
              Select All
            </button>

            <button hlmBtn size="sm" variant="link" class="!p-0 hover:no-underline hover:opacity-50"
                    (click)="clearAll()">Clear All
            </button>
          </div>
        </ng-template>
      }

      @for (option of options; track option) {
        <ng-option [value]="option.value">
          <div class="flex items-center gap-2">
            @if (option.icon) {
              <lucide-icon [name]="option.icon" size="14"></lucide-icon>
            }
            {{ option.label }}
          </div>
        </ng-option>
      }
    </ng-select>
  } @else {
    <ng-select
      [id]="label"
      [readonly]="readOnly"
      [multiple]="multiple"
      (change)="onChange.emit($event)"
      (search)="onSearch.emit($event)"
      [loading]="loading"
      [clearable]="clearable"
      [searchable]="searchable"
      [placeholder]="placeholder">
      @if (multiple) {
        <ng-template ng-header-tmp>
          <div class="flex items-center justify-between px-2 py-1">
            <button hlmBtn size="sm" variant="link" class="!p-0 hover:no-underline hover:opacity-50"
                    (click)="onSelectAll()">
              Select All
            </button>

            <button hlmBtn size="sm" variant="link" class="!p-0 hover:no-underline hover:opacity-50"
                    (click)="clearAll()">Clear All
            </button>
          </div>
        </ng-template>
      }

      @for (option of options; track option) {
        <ng-option [value]="option.value">
          <div class="flex items-center gap-2">
            @if (option.icon) {
              <lucide-icon [name]="option.icon" size="14"></lucide-icon>
            }
            {{ option.label }}
          </div>
        </ng-option>
      }
    </ng-select>
  }

  @if (displayErrors()) {
    @for (err of formControl.errors | keyvalue; track err) {
      <small class="text-error-500 text-xs font-normal">
        {{ errorMessages[err.key] }}
      </small>
    }
  }
</div>
